/**
 * Slick Carousel Library - JavaScript
 * Loaded conditionally via ACF theme options or when patterns require it
 */

import $ from 'jquery';
import 'slick-carousel';

// Make available globally for patterns and inline scripts
if (typeof window !== 'undefined' && $) {
  // Ensure jQuery has slick method available globally
  window.jQuery = $;

  // Also expose as window.slick for any direct usage
  if ($.fn && $.fn.slick) {
    window.slick = $.fn.slick;
  }
}

// Optional: Initialize any slick carousels with data attributes
document.addEventListener('DOMContentLoaded', () => {
  // Auto-initialize carousels with data-slick attribute
  const $autoSlick = $('[data-slick]');
  if ($autoSlick.length && $.fn.slick) {
    $autoSlick.each(function () {
      const $this = $(this);
      const options = $this.data('slick') || {};
      $this.slick(options);
    });
  }
});

export default $.fn.slick;
